import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SeoContext } from '../lib/SeoContext';
import { buildMetadata } from '../lib/seoMetadata';

export default function Seo(props) {
  const { pathname } = useLocation();
  const collector = useContext(SeoContext);
  const meta = buildMetadata(props, pathname);
  if (collector) collector.meta = meta;
  const serialized = JSON.stringify(meta);
  useEffect(() => {
    const data = JSON.parse(serialized);
    document.title = data.title;
    const setMeta = (key, value, attribute = 'name') => {
      let node = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!node) { node = document.createElement('meta'); node.setAttribute(attribute, key); document.head.appendChild(node); }
      node.setAttribute('content', value);
    };
    setMeta('description', data.description);
    setMeta('robots', data.robots);
    Object.entries({ title: data.title, description: data.description, image: data.image, url: data.canonical, type: data.ogType, site_name: "Jonny's Towing & Recovery", locale: 'en_CA' }).forEach(([key, value]) => setMeta(`og:${key}`, value, 'property'));
    Object.entries({ card: 'summary_large_image', title: data.title, description: data.description, image: data.image }).forEach(([key, value]) => setMeta(`twitter:${key}`, value));
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = data.canonical;
    let script = document.head.querySelector('script[data-jonnys-seo="structured-data"]');
    if (!data.structuredData) { script?.remove(); return; }
    if (!script) { script = document.createElement('script'); script.type = 'application/ld+json'; script.dataset.jonnysSeo = 'structured-data'; document.head.appendChild(script); }
    script.textContent = JSON.stringify(data.structuredData);
  }, [serialized]);
  return null;
}
